import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import { CartProvider } from "./context/CartContext";
import { ServicesProvider } from "./context/ServicesContext";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import ServiceDetail from "./pages/ServiceDetail";
import About from "./pages/About";
import Photos from "./pages/Photos";
import Reviews from "./pages/Reviews";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import Admin from "./pages/Admin";
import PayInvoice from "./pages/PayInvoice";
import InvoiceDetail from "./pages/InvoiceDetail";
import PaymentSuccess from "./pages/PaymentSuccess";
import Book from "./pages/Book";
import EditBooking from "./pages/EditBooking";

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <ServicesProvider>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services/:slug" element={<ServiceDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/photos" element={<Photos />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/book" element={<Book />} />
            <Route path="/book/edit/:id" element={<EditBooking />} />
            <Route path="/pay" element={<PayInvoice />} />
            <Route path="/pay/invoice/:id" element={<InvoiceDetail />} />
            <Route path="/pay/success" element={<PaymentSuccess />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </Layout>
        </ServicesProvider>
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
